import toStringFactory from './toStringFactory';
import { typeOfV2 } from './typeOfV2';

export const toStringFilter = toStringFactory({
  toStringCriteria,
  toStringV1,
  toStringOp,
  toStringV2,
  toStringUnion,
  toStringOrderBy,
  toStringGroupBy,
  toStringFromTo,
});

/////////////////////////////////////////////////////////////////////////////////////

function toStringFromTo({ from, to } = {}) {
  if (!from && !to) {
    return '';
  }
  return ` (${from ? `from: ${from}` : ''}${from && to ? ' ' : ''}${to ? `to: ${to}` : ''})`;
}

function toStringOrderBy(value) {
  if (!value) {
    return '';
  }
  return ` ORDER BY ${value}`;
}

function toStringGroupBy(value) {
  if (!value) {
    return '';
  }
  return ` GROUP BY ${value}`;
}

function toStringUnion(union) {
  return union ? ` ${union} ` : '';
}

function toStringCriteria({ v1, op, v2 }) {
  return `${toStringV1({ v1, op, v2 })} ${toStringOp({ v1, op, v2 })} ${toStringV2({ v1, op, v2 })}`;
}

function toStringV1({ v1, op, v2 }) {
  return v1 || '';
}

function toStringOp({ v1, op, v2 }) {
  return op || '';
}

export function toStringV2({ v1, op, v2 }) {
  if (['IN', 'NOT IN'].includes(op)) {
    v2 = v2 || '';
    return `[${v2
      .split(',')
      .map(s => s.trim())
      .join(', ')}]`;
  }
  // let type = typeof v2;
  // if (type === 'object' && Array.isArray(v2)) type = 'array';
  // if (type === 'object' && v2 instanceof Date) type = 'date';
  const type = typeOfV2({ v2 });
  switch (type) {
    case 'string':
      return `"${v2}"`;
    // return `${v2}`;
    case 'number':
      return v2;
    case 'array':
      return `[${v2.split(',').join(', ')}]`;
    case 'date':
      return v2.toLocaleString();
    default: {
      /* sonar */
    }
    // throw new Error(`El valor del filtro tiene un tipo "${type}" desconocido`);
  }
  return v2;
}
